const WORKOUT_SECTION_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',

  NAME: 'name',
  NOTES: 'notes',
  ORDER: 'order',
  TYPE: 'type',

  // Associations
  WORKOUT_EXERCISES: 'workoutExercises',

  // Foreign keys
  WORKOUT_ID: 'workoutId',
  PROFILE_ID: 'profileId'
}

export { WORKOUT_SECTION_KEY }
const WORKOUT_SECTION_CLASS_NAME = 'WorkoutSection'

export { WORKOUT_SECTION_CLASS_NAME }

const WORKOUT_SECTION_ASSOCIATION_KEYS = [
  WORKOUT_SECTION_KEY.WORKOUT_EXERCISES
]

export { WORKOUT_SECTION_ASSOCIATION_KEYS }

const WORKOUT_SECTION_FOREIGN_KEYS = [
  WORKOUT_SECTION_KEY.WORKOUT_ID
]

export { WORKOUT_SECTION_FOREIGN_KEYS }
// import { WORKOUT_SECTION_KEY } from './constants/workout-section/key'

const WORKOUT_SECTION_PRIVATE_KEYS = []

export { WORKOUT_SECTION_PRIVATE_KEYS }

const WORKOUT_SECTION_SCOPE = {

  /**
   * Only returns the public attributes of the Exercise.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: WORKOUT_SECTION_PRIVATE_KEYS
    }
  }

}

export { WORKOUT_SECTION_SCOPE }
const WORKOUT_SECTION_TYPE = {
  WARMUP: 1,
  STRENGTH: 2,
  CIRCUIT: 3,
  CARDIO: 4,
  COOLDOWN: 5
}

export { WORKOUT_SECTION_TYPE }

const WORKOUT_SECTION_TYPE_NAME = Object.keys(WORKOUT_SECTION_TYPE)
  .reduce((obj, typeKey) => {
    const typeName = typeKey
      .replace(/_/g, ' ')
      .replace(/\w\S*/g,
        str => str.charAt(0)
          .toUpperCase() +
          str.substr(1)
            .toLowerCase()
      )
    const typeId = WORKOUT_SECTION_TYPE[typeKey]
    obj[typeId] = typeName
    return obj
  }, {})

export { WORKOUT_SECTION_TYPE_NAME }

export default WORKOUT_SECTION_TYPE

export const WORKOUT_SECTION_ASSOCIATIONS = [
  WORKOUT_SECTION_KEY.WORKOUT_EXERCISES
]
